import React, { useState } from "react";
import {
  Paper,
  Typography,
  Grid,
  CircularProgress,
  Box,
  Button,
} from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { CardFormValues } from "../../../../../types/Card";
import { useCurrentTalentProfile } from "../../../../../hooks";
import { useNavigate } from "react-router-dom";
import { CardDesign } from "../UserCardDesign/UserViewCardDesign";

interface TalentCardListProps {
  cards: CardFormValues[];
}

export default function TalentCardList_updated_dashboard({
  cards,
}: TalentCardListProps) {
  const navigate = useNavigate();
  const { currentProfile } = useCurrentTalentProfile();
  const [hoveredCardId, setHoveredCardId] = useState<string | null>(null);

  const handleCardClick = (id: string) => {
    navigate(`/cards/${id}`);
  };

  return (
    <Paper
      elevation={0}
      sx={{
        p: { xs: 2, md: 4 },
        my: 3,
        mx: "auto",
        width: "100%",
        maxWidth: 1280,
        backgroundColor: "#fff",
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          alignItems: { xs: "flex-start", sm: "center" },
          justifyContent: "space-between",
          gap: 2,
          mb: 4,
        }}
      ></Box>

      {cards.length === 0 ? (
        <Box
          sx={{
            textAlign: "center",
            p: "60px 20px",
            background: "#F9FAFB",
            borderRadius: "16px",
            border: "1px dashed #E5E7EB",
          }}
        >
          <img
            src="/assets/empty-box.svg"
            alt="No Cards"
            style={{ width: 100, marginBottom: 20 }}
          />
        </Box>
      ) : (
        <Box
          sx={{
            display: "grid",
            gap: {
              xs: 1.5,
              sm: 3,
            },
            gridTemplateColumns: {
              xs: "repeat(2, 1fr)", // Always 2 cards on all mobile sizes
              sm: "repeat(2, 1fr)",
              md: "repeat(auto-fit, minmax(280px, 1fr))", // Adjust for larger screens
              lg: "repeat(auto-fit, minmax(300px, 1fr))",
            },

            justifyContent: "center",
          }}
        >
          {cards.map((card) => (
            <Box
              key={card.id}
              sx={{
                width: "100%", // Allow full grid cell width
                display: "flex", // Optional, if CardDesign is block-level
                justifyContent: "center", // center content if CardDesign has fixed width
              }}
            >
              <CardDesign
                card={card}
                isHovered={hoveredCardId === card.id}
                onClickByTalent={() => handleCardClick(card.id)}
                onEdit={() => {}}
                onDelete={() => {}}
                onDeactivate={() => {}}
                isTalent={true}
              />
            </Box>
          ))}
        </Box>
      )}
    </Paper>
  );
}
